import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { UPDATE_OUTLET, UPDATE_OUTLET_ERROR, UPDATE_OUTLET_SUCCESS } from '../../actions.js';

function* updateOutlet({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/digital/outlets/${payload?.id}`,
      method: 'PUT',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: UPDATE_OUTLET_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);

      yield put({
        type: UPDATE_OUTLET_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_OUTLET_ERROR, payload: error });
  }
}

export function* watchUpdateOutlet() {
  yield takeEvery(UPDATE_OUTLET, updateOutlet);
}

function* updateOutletSaga() {
  yield all([fork(watchUpdateOutlet)]);
}

export default updateOutletSaga;
